import api from 'base/utils/api';
import { INavItem, INavLists } from 'mod/store/nav/interface';

/**
 * 获取商品导航（页头导航）配置
 * @param lang 语言
 */
export function getProductNav(lang: string): Promise<INavLists> {
    return api.get('/web/featureConfig/navigation', {
        fetchOptions: {
            headers: {
                Lang: lang
            }
        }
    }).catch(err => {
        console.log(err);
        return {
            list: [],
            quickLinkList: []
        };
    });
}
